import { Button, ButtonProps, Flex, Popover, PopoverProps } from "antd";
import { ReactNode, useState } from "react";

export interface DeletePopoverProps extends PopoverProps {
  onCancel?: () => Promise<any>;
  onConfirm1?: () => Promise<any>;
  onConfirm2?: () => Promise<any>;
  button1Props?: ButtonProps;
  button2Props?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  description?: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  hideCancel?: boolean;
}

export default function DoublePopoverConfirm({
  button1Props,
  button2Props,
  cancelButtonProps,
  description,
  children,
  icon,
  disabled = false,
  onConfirm1,
  onConfirm2,
  onCancel,
  hideCancel = false,
  ...props
}: DeletePopoverProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirming1, setIsConfirming1] = useState(false);
  const [isConfirming2, setIsConfirming2] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);

  const onDelete1Click = () => {
    if (onConfirm1) {
      setIsConfirming1(true);
      onConfirm1?.()
        .then(() => {
          setIsOpen(false);
          setIsConfirming1(false);
        })
        .catch(() => setIsConfirming1(false));
    }
  };

  const onDelete2Click = () => {
    if (onConfirm2) {
      setIsConfirming2(true);
      onConfirm2?.()
        .then(() => {
          setIsOpen(false);
          setIsConfirming2(false);
        })
        .catch(() => setIsConfirming2(false));
    }
  };

  const onCancelClick = () => {
    if (onCancel) {
      setIsCanceling(true);
      onCancel?.()
        .then(() => {
          setIsOpen(false);
          setIsCanceling(false);
        })
        .catch(() => setIsCanceling(false));
    } else {
      setIsOpen(false);
    }
  };

  const content = (
    <>
      <Flex gap={16}>
        <span>{icon}</span>
        <div>{description}</div>
      </Flex>
      <Flex
        justify="flex-end"
        gap={8}
      >
        {!hideCancel && (
          <Button
            disabled={disabled}
            size="small"
            {...cancelButtonProps}
            onClick={onCancelClick}
            loading={isCanceling}
          />
        )}
        {onConfirm1 && (
          <Button
            disabled={disabled}
            size="small"
            {...button1Props}
            onClick={onDelete1Click}
            loading={isConfirming1}
          />
        )}
        {onConfirm2 && (
          <Button
            disabled={disabled}
            size="small"
            {...button2Props}
            onClick={onDelete2Click}
            loading={isConfirming2}
          />
        )}
      </Flex>
    </>
  );

  return (
    <Popover
      {...props}
      open={isOpen}
      onOpenChange={setIsOpen}
      content={content}
    >
      {children}
    </Popover>
  );
}
